import {toast } from 'react-toastify';
import { BaseUrl } from './Url';

export const get = async (url , setData,setIsloading) => {
    var token = localStorage.getItem("token");

    var headers;
    if(token == "" || token == null || token == undefined ){
        headers ={
            "Content-Type" : "application/json",
        };
        localStorage?.clear();
    }
    else{
        headers = {
            "Content-Type" : "application/json",
            "x-access-token": token,
        };
    }

    const completeUrl = BaseUrl + url ;
  

    try {
        const res = await fetch(completeUrl,{
           method:"GET",
           headers
        });
        const response = await res.json();
        if(res.status === 200){
            setIsloading(false);
            setData(response.data);
        }else if(res.status === 401){
            window?.location?.replace('/');
            setIsloading(false);
            localStorage?.clear();
        }
        else{
            alert('kkkk')
            localStorage?.clear()
        }
    }catch(error){
        return error ;
        localStorage?.clear()
    }
}


export const post = async (url , body,setData, setIsLoading) => {
    setIsLoading(true);
    
    var token = localStorage.getItem("token");

    var headers;
    if(token == "" || token == null || token == undefined ){
        headers ={
            "Content-Type" : "application/json",
        };
        localStorage?.clear();
    }
    else{
        headers = {
            "Content-Type" : "application/json",
             'x-access-token': token,
        };
    }

    const completeUrl = BaseUrl + url ;

    try {        
        const res = await fetch(completeUrl,{
           method:"POST",
           headers,
           body,
        });

        const response = await res.json();
        let httpsStatus =res.status
        
        if(httpsStatus == 200){
            setData(response?.data); 
            setIsLoading(false);           
        }
        else if(httpsStatus == 401){
            toast.error('Please Login again');
            //local storage clear
            // navigate to login screen``
            localStorage?.clear()
            setIsLoading(false);
        }else{
            toast.error(response?.message);
            setIsLoading(false);
        }
    }catch(error){
        return error ;
    }
}


export const verifyUserPost = async (url, setData ) => {
    var token = localStorage.getItem("token");
    var headers;
    if(token == "" || token == null || token == undefined ){
        headers ={
            "Content-Type" : "application/json",
        };
        localStorage?.clear();
    }
    else{
        headers = {
            "Content-Type" : "application/json",
             Authorization: `Bearer ${token}`,
        };
    }

    const completeUrl = BaseUrl + url ;

    try {
        const res = await fetch(completeUrl,{
           method:"POST",
           headers,
        });
        const response = await res.json();
        if(res.status !== 200){
            toast.error(response?.response);
        }
        else{
            setData(response);
        }
    }catch(error){
        return error ;
    }
}


/* User  enable and  disable*/
export const enableUSer = async (url, catId ,setIsloading) => {
    setIsloading(true);
    var token = localStorage.getItem("token");
    var headers;
    if(token == "" || token == null || token == undefined ){
        headers ={
            "Content-Type" : "application/json",
        };
        localStorage?.clear();
    }
    else{
        headers = {
            "Content-Type" : "application/json",
            "x-access-token": token,
        };
    }

    const completeUrl = BaseUrl + url +"/"+ catId ;

    try {
        const res = await fetch(completeUrl,{
           method:"post",
           headers
        });
        const response = await res.json();
        let httpsStatus =res.status
        if(httpsStatus == 200){
             setIsloading(false);
        }
        else if(httpsStatus == 401){
            toast.error('Please Login again');
            localStorage?.clear()
            setIsloading(false);
        }else{
            toast.error(response?.message);
            setIsloading(false);
        }
    }
    catch(error){
        console.log("error", error);
        return error ;
    }
}


// Search API
export const searchData = async (url , body,setData) => {
    var token = localStorage.getItem("token");
    var headers;
    if(token == "" || token == null || token == undefined ){
        headers ={
            "Content-Type" : "application/json",
        };
    }
    else{
        headers = {
            "Content-Type" : "application/json",
             'x-access-token': token,
        };
    }

    const completeUrl = BaseUrl + url ;

    try {        
        const res = await fetch(completeUrl,{
           method:"POST",
           headers,
           body,
        });
        const response = await res.json();
        let httpsStatus =res.status
        if(httpsStatus == 200){
            setData(response?.data);            
        }
        else if(httpsStatus == 401){
            toast.error('Please Login again');
            localStorage?.clear()
        }else{
            toast.error(response?.message);
        }
    }catch(error){
        return error ;
    }
}